module.exports = __webpack_public_path__ + "static/media/summary-chart.e32990a9.svg";